import * as Sentry from '@sentry/angular';
import { Injectable } from '@angular/core';

const chunkFailedMessage = /Loading chunk [\d]+ failed/;
const failedModuleScript = /Failed to load module script/;

@Injectable()
export class LoadScriptHandler extends Sentry.SentryErrorHandler {
  constructor() {
    super({ showDialog: false });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public override handleError(error: any): void {
    if (failedModuleScript.test(error.message) || chunkFailedMessage.test(error.message)) {
      window.location.reload();
    }

    super.handleError(error);
  }
}
